import { createSelector } from 'reselect';

const curriculum = (state) => state.get('curriculum');

export const getAllCurriculum = createSelector(curriculum, (curriculum) => curriculum && curriculum.toJS());

export const getCurriculum = (id) => {
  return createSelector(curriculum, (curriculum) => curriculum.get(id).toJS());
};
